import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { Observable } from 'rxjs';
import { categoryFavoriteEntity, categoryFavoriteState } from '../state/category-favorite.models';

@Injectable({
  providedIn: 'root',
})
export class CategoryFavoriteService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  private client = inject(CLIENT_DATA).name;

  getCategoryFavorites(language?: string): Observable<categoryFavoriteEntity> {
    let url = this.apiData.apiURL + `api/${this.client}/favorite/category/de`;
    if (language) {
      url = this.apiData.apiURL + `api/${this.client}/favorite/category/` + language;
    }

    return this.http.get<categoryFavoriteEntity>(url);
  }

  setCategoryFavoriteForId(id: string): Observable<categoryFavoriteState> {
    const url = this.apiData.apiURL + `api/${this.client}/favorite/category/${id}`;
    return this.http.post<categoryFavoriteState>(url, {});
  }

  deleteCategoryFavoriteForId(id: string): Observable<categoryFavoriteState> {
    const url = this.apiData.apiURL + `api/${this.client}/favorite/category/${id}`;
    return this.http.delete<categoryFavoriteState>(url);
  }
}
